const BeaconServiceFactory = (NewBackendService, LoginService, uiConfig, $q, $log) => {
  'ngInject';

  const sendBeaconEmailRequest = (reason, comments, name, receiverAddress) => $q((resolve, reject) => {
    const SHARE_IBAN_EMAIL_URL = 'notifiche/sendDirectEmail';
    const EMAIL_SENDER = uiConfig.EmailSender;
    const EMAIL_TEMPLATE = 'invio_mail_richiesta_beacon';
    const request = {
      data: {
        request: {
          sendDirectEmailRequest: {
            sender: EMAIL_SENDER,
            recipient: receiverAddress, // questo che cos'e?
            templateName: EMAIL_TEMPLATE,
            placeholderMap: {
              reason,
              comments,
              name
            }
          }
        }
      }
    };

    NewBackendService.invokeWebApiPost(SHARE_IBAN_EMAIL_URL, request, true).then((result) => {
      $log.debug(`EmailService`, `sendBeaconRequestViaEmail`, result);
      resolve(result);
    }, (error) => {
      $log.error(`EmailService`, `sendBeaconRequestViaEmail`, error);
      reject(error);
    });
  });


  const service = {
    sendBeaconRequest: (reason, comment) => {
      const registryWallet = LoginService.getRegistryWallet().dtoUserRegistryWallet.dtoUserRegistry;
      const email = registryWallet.email;
      const name = `${registryWallet.name} ${registryWallet.surname}`; // qui che ci vuole il nome dell'user? l'id anagrafica?idUser?

      sendBeaconEmailRequest(reason.label, comment, name, email);  // mandiamo la label o il valore della reason?
    }
  };

  return service;
};

export default BeaconServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/beacon.factory.js
 **/